import type { FC } from 'react';
import { memo } from 'react';

import { PreviewSwitch } from './PreviewSwitch';
import type { IProcessPreview } from './types';

export const ProcessPreview: FC<IProcessPreview> = memo((props) => {
  const { url, loading, spinnersize, Fallback, ...rest } = props;

  return url ? (
    <PreviewSwitch url={url} Fallback={Fallback} spinnersize={spinnersize as number} {...rest} />
  ) : (
    <Fallback />
  );
});
